import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Griddle, {
  ColumnDefinition,
  RowDefinition,
  plugins,
} from "griddle-react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
// core components
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";

import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import CardBody from "components/Card/CardBody.jsx";

import ReactLoading from "react-loading";
import httpr from "lib/httpRequest";
import { BASE_URL, AUTH_OPTIONS } from "lib/config";
import { AuthProvider, AuthConsumer } from "react-check-auth";

const styles = (theme) => ({
  //const styles = {
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  formControl: {
    margin: theme.spacing.unit,
    width: "99%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
});

const NewLayout = ({ Table, Pagination }) => (
  <div>
    <Table />
    <Pagination />
  </div>
);

class CustomTable extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      tableData: props.tableData,
      isLoading: true,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.tableType !== "Emails") {
      if (
        this.props.tableData === undefined ||
        this.props.tableData.length === 0
      ) {
        this.getTableData();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.tableType === "Emails") {
      if (this.props.tableData !== prevProps.tableData) {
        if (this._isMounted === true) {
          this.setState({ tableData: this.props.tableData, isLoading: false });
        }
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getTableData() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}${this.props.dataUrl}`)
        .then((response) => {
          if (this.props.tableType === "Replication") {
            const tmpData = [];

            response.data.map((rep) => {
              Object.keys(rep).map((key) => {
                const latestLogin = new Date(rep[key].latestLogin);
                const latestTransaction = new Date(rep[key].latestTransaction);

                tmpData.push({
                  location: key,
                  latestLogin: latestLogin.toLocaleString("en-US"),
                  latestTransaction: latestTransaction.toLocaleString("en-US"),
                  status: rep[key].status,
                });
              });
            });

            if (this._isMounted === true) {
              this.setState({ tableData: tmpData, isLoading: false });
            }
          } else {
            if (this._isMounted === true) {
              this.setState({ tableData: response.data, isLoading: false });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  getKey() {
    return Math.floor(Math.random() * 100);
  }

  render() {
    let {
      loading,
      classes,
      tableHead,
      tableHeaderColor,
      tableTitle,
      tableType,
      dataUrl,
    } = this.props;
    const { tableData } = this.state;

    let styleConfig = {
      icons: {
        TableHeadingCell: {
          sortDescendingIcon: <div />,
          sortAscendingIcon: <div />,
        },
      },
      classNames: {
        Table: `${classes.table}`,
        TableHeadingCell: `${classes.tableHeadCell}`,
        TableHeading: `${classes[tableHeaderColor + "TableHeader"]}`,
        Cell: `${classes.tableCell}`,
        Row: `${classes.tableRow}`,
      },
    };

    const checkBoxStyles = {
      block: {
        maxWidth: 250,
      },
      checkbox: {
        marginBottom: 16,
      },
    };

    const CheckmarkColumn = ({ value, griddleKey, data }) => {
      const sel = value === 0 ? false : true;
      return (
        <div>
          <Checkbox checked={sel} />
        </div>
      );
    };

    const AmountColumn = ({ value, griddleKey, data }) => {
      return <div>${value}</div>;
    };

    const StatusColumn = ({ value, griddleKey, data }) => {
      return <div style={{ color: "#ff0000" }}>{value}</div>;
    };

    const AdminColumn = ({ value, griddleKey, data }) => {
      const access = value === 0 ? "User" : "Admin";
      return <div>{access}</div>;
    };

    const ActionColumn = ({ value, griddleKey, data }) => {
      const access = value === 0 ? "User" : "Admin";
      const mem = this.state.tableData[griddleKey];
      const memId = mem.MemberId;
      const isAdmin = this.props.isAdmin;

      // Logic to display edit/delete options for members/users

      return (
        <div>
          {/* If user is not admin, only allow edit option for their own account, otherwise show it for all */}
          {(memId === this.props.memberId || isAdmin) && (
            <Tooltip
              id="tooltip-top"
              title="Edit User"
              placement="top"
              classes={{ tooltip: classes.tooltip }}
            >
              <IconButton
                onClick={() => {
                  this.props.editMember(memId);
                }}
                aria-label="Edit"
                className={classes.tableActionButton}
              >
                <Edit
                  className={classes.tableActionButtonIcon + " " + classes.edit}
                />
              </IconButton>
            </Tooltip>
          )}
          {memId !== this.props.memberId &&
            isAdmin && (
              <Tooltip
                id="tooltip-top-start"
                title="Remove User"
                placement="top"
                classes={{ tooltip: classes.tooltip }}
              >
                <IconButton
                  onClick={() => {
                    this.props.deleteMember(mem);
                  }}
                  aria-label="Close"
                  className={classes.tableActionButton}
                >
                  <Close
                    className={
                      classes.tableActionButtonIcon + " " + classes.close
                    }
                  />
                </IconButton>
              </Tooltip>
            )}
        </div>
      );
    };

    const { deleteUrl } = this.props;

    const DeleteActionColumn = ({ value, griddleKey, data }) => {
      const mem = tableData[griddleKey];
      const endPoint = `${deleteUrl}${value}`;

      return (
        <div>
          <Tooltip
            id="tooltip-top-start"
            title={tableType === "members" ? "Remove User" : "Remove"}
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <IconButton
              onClick={() => {
                this.setState({});
                this.props.deleteAction(endPoint);
              }}
              aria-label="Close"
              // className={classes.tableActionButton}
            >
              <Close
                className={classes.tableActionButtonIcon + " " + classes.close}
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    };

    const rowDataSelector = (state, { griddleKey }) => {
      return state
        .get("data")
        .find((r) => r.get("griddleKey") === griddleKey)
        .toJSON();
    };

    const enhancedWithRowData = connect((state, props) => {
      return {
        rowData: rowDataSelector(state, props),
      };
    });

    let tableRowDef = <RowDefinition />;

    if (tableType === "OpenTill") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="user_id" title="User ID" />
          <ColumnDefinition id="terminal_id" title="Terminal ID" />
          <ColumnDefinition id="register_id" title="Register ID" />
          <ColumnDefinition id="SECONDARY_ID" title="Secondary ID" />
          <ColumnDefinition id="user_name" title="User Name" />
          <ColumnDefinition
            id="LAST_DISPENSE_DATE"
            title="LAST DISPENSE DATE"
          />
          <ColumnDefinition id="TRANS_TYPE_NAME" title="Trans Type Name" />
        </RowDefinition>
      );
    }

    if (tableType === "Replication") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="location" title="Location" />
          <ColumnDefinition id="latestLogin" title="Latest Login" />
          <ColumnDefinition id="latestTransaction" title="Latest Transaction" />
          <ColumnDefinition
            id="status"
            title="Status"
            customComponent={StatusColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Members") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition
            id="Admin"
            title="Type"
            customComponent={AdminColumn}
          />
          <ColumnDefinition id="Email" title="Email" />
          <ColumnDefinition id="FirstName" title="First Name" />
          <ColumnDefinition id="LastName" title="Last Name" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition id="Reports" title="Reports" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(ActionColumn)}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Phones") {
      styleConfig = {
        icons: {
          TableHeadingCell: {
            sortDescendingIcon: <div />,
            sortAscendingIcon: <div />,
          },
        },
        classNames: {
          Table: `${classes.table}`,
          TableHeadingCell: `${classes.tableHeadCell}`,
          TableHeading: `${classes[tableHeaderColor + "TableHeader"]}`,
          Cell: `${classes.tableCell}`,
          Row: `${classes.tableRowLeft}`,
        },
      };

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="PhoneNumber" title=" " />
          <ColumnDefinition
            width={"10%"}
            id="Id"
            title=" "
            customComponent={enhancedWithRowData(DeleteActionColumn)}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Emails") {
      styleConfig = {
        icons: {
          TableHeadingCell: {
            sortDescendingIcon: <div />,
            sortAscendingIcon: <div />,
          },
        },
        classNames: {
          Table: `${classes.table}`,
          TableHeadingCell: `${classes.emailTableHeadCell}`,
          TableHeading: `${classes[tableHeaderColor + "TableHeader"]}`,
          Cell: `${classes.emailTableCell}`,
          Row: `${classes.tableRowLeft}`,
        },
      };

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="Email" title="Email" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition
            width={"1%"}
            id="Id"
            title=" "
            customComponent={enhancedWithRowData(DeleteActionColumn)}
          />
        </RowDefinition>
      );
    }

    return (
      <div>
        {this.state.isLoading === true ? (
          <div>
            <CardBody>
              <ReactLoading
                type="spin"
                color="#000000"
                style={{
                  width: "20%",
                  margin: "auto",
                }}
              />
            </CardBody>
          </div>
        ) : (
          <div>
            <CardBody>
              <div className={classes.tableContainer}>
                <Griddle
                  data={this.state.tableData}
                  plugins={[plugins.LocalPlugin]}
                  key={this.props.key}
                  styleConfig={styleConfig}
                  components={{
                    Layout: NewLayout,
                  }}
                >
                  {tableRowDef}
                </Griddle>
              </div>
            </CardBody>
          </div>
        )}
      </div>
    );
  }
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "scmain",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(tableStyle)(CustomTable);



// WEBPACK FOOTER //
// ./src/components/Table/CustomTable.jsx